import { brand, memo, updatedAt } from '@/pages/menu-managements/const';
import { Title } from '@/pages/menu-managements/services/title';

export type MenuForm = typeof menuForm;

const titleJa = {
  key: 'titleJa',
  label: 'メニュー名',
};

export const menuForm = {
  brand,
  titleJa,
  memo,
} as const;

const tableColumns = [
  {
    ...titleJa,
    width: '250px',
  },
  {
    ...memo,
    width: '250px',
  },
  {
    ...updatedAt,
    width: '180px',
  },
] as const;

export const menuTableThs = tableColumns.map((tableColumn) => {
  return {
    label: tableColumn.label,
    minWidth: tableColumn.width,
  };
});

export type MenuManagementBrandMenu = {
  id: number;
  title: Title;
  memo: string | null;
  updated_at: Date;
};
